import React from 'react';
import '../index.css';
//Importing bootstrap and other modules
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.min.js';
import 'popper.js/dist/umd/popper.min.js'
import $ from 'jquery';
import { Navbar, Nav, Image, Container } from 'react-bootstrap'
import SearchIcon from '@material-ui/icons/Search';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import DashboardContent from './DashbordContent';
import TableContent from './TableContent';
import Monitor from './Monitor';
import Task from './Task';
import Note from './Note';
import check from './Check';
import Admin from './Admin';
import Cloud from './Cloud';
import Graph from './Graph';
import Pic from './Pic';


class SideBar extends React.Component {


    componentDidMount() {
        // Sidebar Toggle Menu Click
        $("#menu-toggle").click(function (e) {
            e.preventDefault();
            $("#wrapper").toggleClass("toggled");
        });
    }



    render() {
        return (
            <div className="MainDiv">
                <Router>
                    <div className="d-flex" id="wrapper">
                        <div className="left-sidebar border-right" id="sidebar-wrapper">

                            <div className="sidebar-heading">Gull</div>
                            <div class="flex-container text-center">

                                <Link to='/' className="link">
                                    <div className="effect mt-2">
                                        <Image src="img/sidebar/1.png" className='mt-3 ' alt="Dashboard icon" /><br />
                                        <div className="hide">  <span >Dashboard</span></div>
                                    </div>
                                </Link>

                                <Link to="/TableContent" className="link"  >

                                    <div className='effect mt-3'>
                                        <Image src="img/sidebar/2(1).png" alt="Table icon" /><br />
                                        <span>Table</span>
                                    </div>
                                </Link>

                                <Link to="/Monitor" className="link"  >

                                    <div className='effect mt-3'>
                                        <Image src="img/sidebar/2.png" alt="computer icon" /><br />
                                        <span>Monitor</span>
                                    </div>
                                </Link>


                                <Link to="/Task" className="link"  >
                                    <div className='effect mt-3'>
                                        <Image src="img/sidebar/3.png" alt="Notes icon" /><br />
                                        <span>Notes</span>
                                    </div>
                                </Link>


                                <Link to="/Note" className="link"  >
                                    <div className='effect mt-3'>
                                        <Image src="img/sidebar/4.png" alt="Task icon" /><br />
                                        <span>Task</span>
                                    </div>
                                </Link>


                                <Link to="/Check" className="link"  >
                                    <div className='effect mt-3'>
                                        <Image src="img/sidebar/5.png" alt="Check icon" /><br />
                                        <span>Check</span>
                                    </div>
                                </Link>


                                <Link to="/Admin" className="link"  >
                                    <div className='effect mt-3'>
                                        <Image src="img/sidebar/6.png" alt="Admin icon" /><br />
                                        <span>Admin</span>
                                    </div>
                                </Link>


                                <Link to="/Cloud" className="link"  >
                                    <div className='effect mt-3'>
                                        <Image src="img/sidebar/7.png" alt="Cloud icon" /><br />
                                        <span>Cloud</span>
                                    </div>
                                </Link>

                                <Link to="/Graph" className="link"  >
                                    <div className='effect mt-3'>
                                        <Image src="img/sidebar/8.png" alt="Graph icon" /><br />
                                        <span>Graph</span>
                                    </div>
                                </Link>

                                <Link to="/Pic" className="link"  >
                                    <div className='effect mt-3'>
                                        <Image src="img/sidebar/9.png" alt="Image icon" /><br />
                                        <span>Image</span>
                                    </div>
                                </Link>

                            </div>
                        </div>
                        <div id="page-content-wrapper">

                            <Navbar className='nav-bg ' variant="light">

                                <Navbar.Brand  id='menu-toggle'>
                                    <Image src='img/header/nav.png' className='mx-3' id="menu-toggle" alt='menu img' />

                                </Navbar.Brand>

<div className="box">
<SearchIcon className="i" /><input type="text" placeholder='Search' />


</div>

                               


                                <Container>

                                    <Nav className="ms-auto">
                                        <Nav.Link>

                                            <span>     <Image src='img/header/line.png' alt='person-img' ></Image> </span>

                                        </Nav.Link>
                                        <Nav.Link>


                                            <div class="notification">
                                                <span>     <Image src='img/header/bell.png' alt='person-img' ></Image> </span>
                                                <span class="badge">3</span>
                                            </div>

                                        </Nav.Link>
                                        <Nav.Link >
                                            <Image src='img/header/header-img.png' height='30px' alt='person-img' ></Image>
                                        </Nav.Link>
                                    </Nav>
                                </Container>
                            </Navbar>

                            <div className="container-fluid">





                                <Switch>
                                    <Route path="/Check" exact component={check} />
                                    <Route path="/Admin" exact component={Admin} />
                                    <Route path="/Cloud" exact component={Cloud} />
                                    <Route path="/Graph" exact component={Graph} />
                                    <Route path="/Pic" exact component={Pic} />


                                    <Route path="/Note" exact component={Note} />
                                    <Route path="/Task" exact component={Task} />
                                    <Route path="/Monitor" exact component={Monitor} />
                                    <Route path="/TableContent" exact component={TableContent} />
                                    <Route path="/" exact component={DashboardContent} />
                                </Switch>




                            </div>
                        </div>
                    </div>



                </Router>




            </div>


        );
    }
}
export default SideBar;